import { render, staticRenderFns } from "./CrossErrorIcon.vue?vue&type=template&id=9f64c1f4"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f64c1f4')) {
      api.createRecord('9f64c1f4', component.options)
    } else {
      api.reload('9f64c1f4', component.options)
    }
    module.hot.accept("./CrossErrorIcon.vue?vue&type=template&id=9f64c1f4", function () {
      api.rerender('9f64c1f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/CrossErrorIcon.vue"
export default component.exports